import { render, staticRenderFns } from "./calculo.vue?vue&type=template&id=5502cb36"
import script from "./calculo.vue?vue&type=script&lang=js"
export * from "./calculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports